<template>
	<Col class="page-container width-100 height-100 overflow-y-auto pa-9">
		<div class="regular-font">This is our regular font 16px</div>
		<div class="new-font mb-12">This is a new font we are trying. 16px. they have the same color.</div>

		<div class="regular-font">This is the same sentence</div>
		<div class="new-font mb-12">This is the same sentence</div>

		<div class="regular-font">This is the same sentence</div>
		<div class="new-font mt-n3 mb-12">This is the same sentence</div>
	</Col>
</template>

<script>
import { mapGettersShorthand } from '@/store/utils/mappers';
import { isDevAccessEnabled } from '@/store/modules/featureFlags/getters.js';
export default {
	name: 'Fonts',
	computed: {
		...mapGettersShorthand({ isDevAccessEnabled }),
	},
	mounted() {
		if (!this.isDevAccessEnabled) {
			this.$router.push({ name: 'HomePage' });
		}
	},
};
</script>
<style scoped lang="scss">
.page-container {
	background: #f9fafc;
}
.regular-font {
	font-size: 16px;
	color: #262626;
}
.new-font {
	font-size: 16px;
	color: #262626;
	font-family: -apple-system, system-ui, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Fira Sans, Ubuntu, Oxygen, Oxygen Sans,
		Cantarell, Droid Sans, Apple Color Emoji, Segoe UI Emoji, Segoe UI Emoji, Segoe UI Symbol, Lucida Grande, Helvetica, Arial, sans-serif !important;
}
</style>
